import React, { useState, useEffect } from "react";
import {
  Filter,
  Create,
  AutocompleteInput,
  TextInput,
  LongTextInput,
  SaveButton,
  List,
  FunctionField,
  Datagrid,
  TextField,
  Pagination,
  ReferenceField,
  Button,
  Link,
  Toolbar,
  Edit,
  SimpleForm,
  EditButton,
  ReferenceInput,
  DateInput,
  NumberInput,
  BooleanInput,
  UPDATE,
  CREATE,
  TabbedForm,
  FormTab,
} from "react-admin";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import LocationRecommendedBikesEdit from '../components/LocationRecommendedBikesEdit'
import moment from "moment";
import { head, prop, path, map, find, propEq, assoc, sort, pluck, isEmpty, all, isNil, reduce } from "ramda";
import dataProviderFactory from "../dataProvider";

const ListPagination = props => (
  <Pagination rowsPerPageOptions={[10, 25, 50, 100]} {...props} />
);

// const Delete = (props) => (
//     <Button
//         component={Link}
//         to={{
//             pathname: `/delete/${props.record.id}`,
//         }}
//         label="Delete">
//     </Button>
// )

const LocationTitle = object => (
  <span>
    {" Edit Loction entry "} {object.record.location_name}
  </span>
);

const LocationCreateTitle = record => <span>Create Location entry</span>;

const LocationsListFilter = props => (
  <Filter {...props}>
    <TextInput label="Location Name" source="location_name" alwaysOn />
    <TextInput
      label="Location 3 Letter"
      source="location3letter_name"
      alwaysOn
    />
  </Filter>
);

export const LocationsList = props => (
  <List
    {...props}
    title="Locations"
    resource="locations"
    pagination={<ListPagination />}
    filters={<LocationsListFilter />}
    filter={{ show_all: true }}
    bulkActionButtons={false}
  >
    <Datagrid>
      <TextField label="Location ID" source="id" />
      <TextField label="Location" source="location_name" />
      <TextField label="Location Short" source="location_short_name" />
      <TextField label="Location 3 Letter" source="location3letter_name" />
      <ReferenceField
        label="Base Location"
        source="base_location_id"
        reference="locations"
        linkType={true}
        allowEmpty={true}
      >
        <FunctionField
          render={location =>
            `${location.location_name} (${location.location3letter_name})`
          }
        />
      </ReferenceField>
      <FunctionField
        label="Active"
        render={location => {
          return location.active ? "Yes" : "No";
        }}
      />
      <FunctionField
        label="Supplier"
        render={user => {
          return user.supplier ? "Yes" : "No";
        }}
      />
      <EditButton />
      {/* <DeleteButton/> */}
    </Datagrid>
  </List>
);

const LocationsToolbar = props => (
  <Toolbar {...props}>
    <SaveButton redirect={`/locations`} />
    {/* <DeleteButton record={props.record} resource={props.resource} redirect={`/black_lists`} />  */}
    <Button
      component={Link}
      to={{
        pathname: `/locations`
      }}
      label="Back to Locations"
    >
      <ArrowBackIcon />
    </Button>
  </Toolbar>
);

const LocationContactEdit = ({ record }) => {
  const [contacts, setContacts] = useState({});
  const [savingDetails, setSavingDetails] = useState(false);
  console.log("Contacts state:", contacts);

  useEffect(() => {
    if (record && record.location_details) {
      const contactsByLanguage = {};
      record.location_details.forEach(detail => {
        if (detail.desc_name.trim() === 'contact') {
          contactsByLanguage[detail.language] = detail;
        }
      });
      setContacts(contactsByLanguage);
    }
  }, [record]);

  const handleChange = (language, value) => {
    console.log("Changing value for language:", language, "to:", value);
    setContacts(prev => ({
      ...prev,
      [language]: {
        ...prev[language],
        descriptor: value
      }
    }));
  };

  const handleSaveClickDetails = async () => {
    setSavingDetails(true);
    try {
      await handleSubmit();
    } catch (error) {
      console.error('Error saving details:', error);
    }
    setSavingDetails(false);
  };

  const handleSubmit = async () => {
    const dataProvider = await dataProviderFactory("rest");
    const locationId = record.id;

    const updateOrCreatePromises = Object.entries(contacts).map(([language, contactData]) => {
      const bodyRequest = {
        data: {
          location_id: locationId,
          language: language,
          desc_name: 'contact',
          descriptor: contactData.descriptor
        }
      };

      if (contactData.id) {
        bodyRequest.id = contactData.id;
        return dataProvider(UPDATE, "location_details", bodyRequest);
      } else if (contactData.descriptor && contactData.descriptor.trim()) {
        return dataProvider(CREATE, "location_details", bodyRequest);
      }
      return null;
    }).filter(Boolean);

    if (updateOrCreatePromises.length === 0) {
      return;
    }

    try {
      await Promise.all(updateOrCreatePromises);
      // Aquí podrías agregar una notificación de éxito si lo deseas
    } catch (error) {
      console.error('Error updating contacts:', error);
      throw error;
    }
  };

  return (
    <div>
      {['es', 'en', 'de', 'pt'].map(language => {
        const contact = contacts[language];
        return (
          <div key={language}>
            <LongTextInput 
              source={`contact_${language}`}
              label={`Contact Information (${language.toUpperCase()})`}
              defaultValue={contact ? contact.descriptor : ''}
              onChange={(e) => handleChange(language, e.target.value)}
              fullWidth
            />
            <input 
              type="hidden" 
              name={`location_details[${language}].id`} 
              value={contact ? contact.id : ''} 
            />
            <input 
              type="hidden" 
              name={`location_details[${language}].desc_name`} 
              value="contact             " 
            />
          </div>
        );
      })}
      <SaveButton
        onClick={handleSaveClickDetails}
        disabled={savingDetails}
        saving={savingDetails}
        label="Save contact details"
      />
    </div>
  );
};

export const LocationsEdit = props => (
  <Edit title={<LocationTitle />} {...props}>
    <TabbedForm toolbar={<LocationsToolbar props={{ ...props }} />}>
      <FormTab label="Location Details">
        <ReferenceInput
          label="Base Location"
          source="base_location_id"
          reference="locations"
          filter={{ only_bases: "true" }}
          sort={{ field: "location_name", order: "ASC" }}
        >
          <AutocompleteInput
            optionText={location =>
              `${location.location_name} (${location.location3letter_name})`
            }
          />
        </ReferenceInput>
        <TextInput label="Location Name" source="location_name" />
        <TextInput label="Location Short Name" source="location_short_name" />
        <TextInput
          source="location3letter_name"
          label="Location 3 Letter Name"
        />
        <ReferenceInput
          label="City"
          source="city_id"
          reference="cities"
          sort={{ field: "city", order: "ASC" }}
        >
          <AutocompleteInput optionText={city => `${city.city}`} />
        </ReferenceInput>
        <ReferenceInput
          label="Country"
          source="country_id"
          reference="countries"
          sort={{ field: "country", order: "ASC" }}
        >
          <AutocompleteInput optionText={country => `${country.country}`} />
        </ReferenceInput>
        <TextInput label="Location Color Short Name" source="color" />
        <TextInput label="Location Header Color" source="header_color" />
        <TextInput label="Screen Order" source="screen_order" />
        <NumberInput label="Vat Tax" source="vat_tax" />
        <BooleanInput source="active" label="Active" />
        <BooleanInput source="supplier" label="Supplier" />
        <LongTextInput source="location_email" label="Email" />
      </FormTab>
      <FormTab label="Recommended Bike Numbers">
        <LocationRecommendedBikesEdit />
      </FormTab>
      <FormTab label="Details contact">
        <LocationContactEdit />
      </FormTab>
    </TabbedForm>
  </Edit>
);

function Fecha(date){
  return moment.utc(date).locale('es').format('YYYY-MM-DD');
}

export const LocationsCreate = props => (
  <Create title={<LocationCreateTitle />} {...props}>
    <SimpleForm>
      <DateInput label="Date" source="date" locales="es-Es" options={{ timeZone: 'UTC' }} />
      <ReferenceInput
        label="Base Location"
        source="base_location_id"
        reference="locations"
        filter={{ only_bases: "true" }}
        sort={{ field: "location_name", order: "ASC" }}
      >
        <AutocompleteInput
          optionText={location =>
            `${location.location_name} (${location.location3letter_name})`
          }
        />
      </ReferenceInput>
      <TextInput label="Location Name" source="location_name" />
      <TextInput label="Location Short Name" source="location_short_name" />
      <LongTextInput
        source="location3letter_name"
        label="Location 3 Letter Name"
      />
      <ReferenceInput
        label="City"
        source="city_id"
        reference="cities"
        sort={{ field: "city", order: "ASC" }}
      >
        <AutocompleteInput optionText={city => `${city.city}`} />
      </ReferenceInput>
      <ReferenceInput
        label="Country"
        source="country_id"
        reference="countries"
        sort={{ field: "country", order: "ASC" }}
      >
        <AutocompleteInput optionText={country => `${country.country}`} />
      </ReferenceInput>
      <TextInput label="Location Color Short Name" source="color" />
      <TextInput label="Location Header Color" source="header_color" />
      <BooleanInput source="active" label="Active" />
      <BooleanInput source="supplier" label="Supplier" />
      <TextInput label="Screen Order" source="screen_order" />
      <NumberInput label="Vat Tax" source="vat_tax" />
      <LongTextInput source="location_email" label="Email" />
    </SimpleForm>
  </Create>
);



// WEBPACK FOOTER //
// ./src/resources/locations.js